import {ElementRef, Injector, NgZone} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {
  ActionSheetController,
  AlertController,
  GestureController,
  MenuController,
  ModalController,
  NavController,
  Platform,
  ViewWillEnter
} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {AuthApiService} from '../../../Services/Api/Auth/auth-api.service';
import {ToastManagerService} from '../../../Services/Platform/Ionic/toast-manager.service';
import {LoaderManagerService} from '../../../Services/Platform/Ionic/loader-manager.service';
import {RoutesEnum} from '../../../Shared/Enum/routes.enum';
import {FilterButtonTypesEnum} from '../../../Shared/Enum/filter-button-types.enum';
import {ClientsEnum} from '../../../Shared/Enum/clients.enum';
import {UserSessionDto} from '../../../Models/User/user-session.interface';
import {EventsManagerService} from '../../../Services/Shared/events-manager.service';
import {AnimationsManagerService} from '../../../Services/Platform/Ionic/animations-manager.service';
import {PermissionsManagerService} from '../../../Services/Shared/permissions-manager.service';
import {DataManagerService} from '../../../Services/Shared/data-manager.service';
import {HapticsImpactManagerService} from '../../../Services/Platform/Capacitor/haptics-impact-manager.service';
import {FiltersModelService} from '../../../Services/Models/Core/filters-model.service';
import {CameraManagerService} from '../../../Services/Platform/Capacitor/camera-manager.service';
import {AppConfigManagerService} from '../../../Services/Shared/app-config-manager.service';
import {TagManagerService} from '../../../Services/Platform/Ionic/tag-manager.service';
import {AppConfigDto} from '../../../Models/Core/app-config.model';
import {PusherManagerService} from '../../../Services/Platform/Capacitor/pusher-manager.service';
import {ScannerManagerService} from '../../../Services/Platform/Capacitor/scanner-manager.service';
import {BarcodeScannerManagerService} from '../../../Services/Platform/Capacitor/barcode-scanner-manager.service';
import {ReaderManagerService} from '../../../Services/Integrations/reader-manager.service';
import {FileViewerManagerService} from '../../../Services/Shared/file-viewer-manager.service';
import {FilePickerManagerService} from '../../../Services/Platform/Capacitor/file-picker-manager.service';
import {SessionManagerService} from '../../../Services/Shared/session-manager.service';
import {LanguageManagerService} from '../../../Services/Shared/language-manager.service';
import {LongPressManagerService} from '../../../Services/Platform/Ionic/long-press-manager.service';

export abstract class PageController implements ViewWillEnter {

  public user!: UserSessionDto | null;
  public appConfig!: AppConfigDto;

  public routesEnum = RoutesEnum;
  public filterButtonTypes = FilterButtonTypesEnum;
  public clientsEnum = ClientsEnum;

  public searchValue: string = '';
  public showSearchbar: boolean = false;

  public tagManager: TagManagerService;
  public longPressManager: LongPressManagerService;
  public permissionsManager: PermissionsManagerService;
  protected auth: AuthApiService;
  protected navCtrl: NavController;
  protected toastCtrl: ToastManagerService;
  protected loadCtrl: LoaderManagerService;
  protected menuCtrl: MenuController;
  protected gestureCtrl: GestureController;
  protected animationCtrl: AnimationsManagerService;
  protected eventsManager: EventsManagerService;
  protected dataManager: DataManagerService;
  protected filtersService: FiltersModelService;
  protected platform: Platform;
  protected ngZone: NgZone;
  protected sanitizer: DomSanitizer;
  protected translate: TranslateService;
  protected activatedRoute: ActivatedRoute;
  protected router: Router;
  protected modalCtrl: ModalController;
  protected alertCtrl: AlertController;
  protected actionSheetCtrl: ActionSheetController;
  protected elementRef: ElementRef;
  protected hapticsImpactManager: HapticsImpactManagerService;
  protected cameraManager: CameraManagerService;
  protected appConfigManager: AppConfigManagerService;
  protected pusherManager: PusherManagerService;
  protected scannerManager: ScannerManagerService;
  protected barcodeScannerManager: BarcodeScannerManagerService;
  protected readerManager: ReaderManagerService;
  protected fileViewerManager: FileViewerManagerService;
  protected filePickerManager: FilePickerManagerService;
  protected sessionManager: SessionManagerService;
  protected languageManager: LanguageManagerService;

  protected constructor(
    protected injector: Injector
  ) {
    this.auth = this.injector.get<AuthApiService>(AuthApiService);
    this.navCtrl = this.injector.get<NavController>(NavController);
    this.toastCtrl = this.injector.get<ToastManagerService>(ToastManagerService);
    this.loadCtrl = this.injector.get<LoaderManagerService>(LoaderManagerService);
    this.menuCtrl = this.injector.get<MenuController>(MenuController);
    this.gestureCtrl = this.injector.get<GestureController>(GestureController);
    this.animationCtrl = this.injector.get<AnimationsManagerService>(AnimationsManagerService);
    this.eventsManager = this.injector.get<EventsManagerService>(EventsManagerService);
    this.platform = this.injector.get<Platform>(Platform);
    this.ngZone = this.injector.get<NgZone>(NgZone);
    this.sanitizer = this.injector.get<DomSanitizer>(DomSanitizer);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.activatedRoute = this.injector.get<ActivatedRoute>(ActivatedRoute);
    this.router = this.injector.get<Router>(Router);
    this.modalCtrl = this.injector.get<ModalController>(ModalController);
    this.alertCtrl = this.injector.get<AlertController>(AlertController);
    this.actionSheetCtrl = this.injector.get<ActionSheetController>(ActionSheetController);
    this.permissionsManager = this.injector.get<PermissionsManagerService>(PermissionsManagerService);
    this.dataManager = this.injector.get<DataManagerService>(DataManagerService);
    this.hapticsImpactManager = this.injector.get<HapticsImpactManagerService>(HapticsImpactManagerService);
    this.filtersService = this.injector.get<FiltersModelService>(FiltersModelService);
    this.elementRef = this.injector.get<ElementRef>(ElementRef);
    this.tagManager = this.injector.get<TagManagerService>(TagManagerService);
    this.cameraManager = this.injector.get<CameraManagerService>(CameraManagerService);
    this.appConfigManager = this.injector.get<AppConfigManagerService>(AppConfigManagerService);
    this.pusherManager = this.injector.get<PusherManagerService>(PusherManagerService);
    this.scannerManager = this.injector.get<ScannerManagerService>(ScannerManagerService);
    this.barcodeScannerManager = this.injector.get<BarcodeScannerManagerService>(BarcodeScannerManagerService);
    this.readerManager = this.injector.get<ReaderManagerService>(ReaderManagerService);
    this.fileViewerManager = this.injector.get<FileViewerManagerService>(FileViewerManagerService);
    this.filePickerManager = this.injector.get<FilePickerManagerService>(FilePickerManagerService);
    this.sessionManager = this.injector.get<SessionManagerService>(SessionManagerService);
    this.languageManager = this.injector.get<LanguageManagerService>(LanguageManagerService);
    this.longPressManager = this.injector.get<LongPressManagerService>(LongPressManagerService);
  }


  ionViewWillEnter() {
    this.user = this.auth.getUserSession();
    this.getAppConfig();
  }


  /**
   * Obtener la configuración de la app
   *
   */
  getAppConfig() {
    this.appConfigManager.getAppConfig().then(() => {
      this.appConfig = this.appConfigManager.appConfig;
      this.languageManager.translateApp(this.appConfig?.language);
    });
  }


  /**
   * Guardar los nuevos cambios de la configuración
   *
   */
  async saveAppConfig() {
    this.appConfigManager.appConfig = this.appConfig;
    await this.appConfigManager.saveAppConfig();
  }


  /**
   * Acceder a la aplicación
   *
   */
  async accessApp() {

    await this.loadCtrl.show(this.translate.instant('DATA.LOADER_MESSAGE'));

    this.dataManager.getData().finally(() => {

      this.loadCtrl.hide();

      setTimeout(() => {
        this.navCtrl.navigateRoot(this.routesEnum.home, {
          animated: true,
          animationDirection: 'forward',
        });
      }, 150);

    });

  }


  /**
   * Ir a la vista
   *
   */
  goToView(path: string, ...params: any[]) {
    this.navCtrl.navigateForward(path, {
      animated: true,
      queryParams: this.getParamsObject(params),
      queryParamsHandling: 'merge'
    });
  }


  /**
   * Retroceder a la vista anterior
   *
   */
  backToView(path: string, ...params: any[]) {
    this.navCtrl.navigateBack(path, {
      animated: true,
      queryParams: this.getParamsObject(params),
      queryParamsHandling: 'merge'
    });
  }


  /**
   * Obtener los parámetros que se han enviado de la vista anterior
   *
   */
  getParamsObject(params: any[]) {
    if (!params) {
      return null;
    }

    return params[0];
  }


  /**
   * Limpiar parámetros
   *
   */
  cleanParams() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {}
    });
  }


  /**
   * Ocultar barra de búsqueda
   *
   */
  toggleSearchbar() {
    this.showSearchbar = !this.showSearchbar;
    this.searchValue = '';
  }


  /**
   * Comprueba si hay algún modal abierto
   *
   */
  checkOpenModals(): boolean {
    const modals: NodeListOf<HTMLIonModalElement> = document.querySelectorAll('ion-modal');
    const modalsArray: HTMLIonModalElement[] = Array.from(modals);

    return modalsArray.length !== 0;
  }


  /**
   * Comprueba si hay algún foco activo
   *
   */
  checkElementFocus(): boolean {
    const inputsElements: NodeListOf<HTMLIonInputElement | HTMLIonTextareaElement> = document.querySelectorAll('ion-input, ion-textarea');
    const inputsElementsArray: (HTMLIonInputElement | HTMLIonTextareaElement)[] = Array.from(inputsElements);

    const searchbarElements: NodeListOf<HTMLIonSearchbarElement> = document.querySelectorAll('ion-searchbar');
    const searchbarElementsArray: HTMLIonSearchbarElement[] = Array.from(searchbarElements);

    return inputsElementsArray.some((input) => input.classList.contains('has-focus')) ||
      searchbarElementsArray.some((searchbar) => searchbar.classList.contains('searchbar-has-focus'));
  }

}
